// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 3000px) {
  .fc .fc-daygrid-day.fc-day-today {
    height: 120px;
  }
}
@media (min-width: 2000px) {
  .fc .fc-daygrid-day.fc-day-today {
    height: 100px;
  }
  .dssolonavbar.navbar .navbar-nav .nav-link {
    padding: 8px 15px;
    font-size: 18px;
  }
}

@media (max-width: 1600px) {
  #compare-community-Modal .item-address {
    margin-right: 0px;
    width: 100%;
  }
  .relonav-login .form-signin {
    margin-left: 10%;
  }
  #compare-community-Modal .item-address img {
    border-radius: 10px;
    width: 160px;
    height: 100px;
  }
  #compare-community-Modal .item-address h2 {
    font-size: 17px;
    max-width: 90%;
  }
  #compare-community-Modal .item-address h1 {
    font-size: 20px;
    font-weight: 700;
  }
  table.compare-table td {
    font-size: 17px;
  }
  table.compare-table th {
    font-size: 17px;
    min-width: 200px;
  }
  .dssolonavbar.navbar .navbar-nav .nav-link {
    padding: 8px 10px;
  }

  .calendar-view-page-schedule .fc .fc-daygrid-day-frame {
    min-height: 60px;
  }
  .calendar-view-page-schedule .fc-view-harness.fc-view-harness-active {
    min-height: 450px;
  }
} /*1600px*/

@media (max-width: 1366px) {
  .relonav-login h1 {
    font-size: 40px;
    margin-top: 25px;
    margin-bottom: 0rem !important;
  }
  .relonav-login img {
    height: 40px;
  }
  .relonav-login .form-signin img {
    height: auto;
    max-width: 100%;
  }
  .relonav-login .btn.btn-dark {
    font-size: 15px;
  }
  .relo-dsLanding .grid-view h1 {
    font-size: 2rem;
  }
  .my_properties_lists .main_grid .item p {
    font-size: 13px;
  }
  .dssolonavbar.navbar .navbar-nav .nav-link {
    padding: 8px 5px;
    font-size: 15px;
  }
  .city-landing-page.newOne .tabs-view ul.nav {
    top: 47px;
  }
  .dssolonavbar.navbar .navbar-collapse {
    margin-right: 160px;
  }
} /*1366px*/
@media (max-width: 1199px) {
  .relo-step-from form {
    width: 100%;
    padding: 25px 30px;
  }
  .relo-step-from .tracker-view {
    width: 100%;
  }
  .relo-step-from form label {
    font-size: 16px;
  }
  .weather-view-page .weather-view-main-details span {
    font-size: 3.5rem;
  }
  .weather-view-page .weather-view-main-details .fa-clouds {
    font-size: 80px;
  }
  .weather-view-page {
    padding-left: 0;
  }
  .weather-view-page .weather-view-week-details .item {
    width: 115px;
    margin: auto;
  }

  .dssolonavbar.navbar .navbar-nav:first-child .nav-item {
    padding: 0;
  }

  .dssolonavbar.navbar .navbar-nav .nav-link {
    font-size: 12px;
    padding: 8px 0px;
    margin: 0 8px;
    display: inline-block;
  }
  .dssolonavbar.navbar .navbar-collapse {
    margin-right: 120px;
  }

  #compare-community-Modal .item-address h2 {
    font-size: 14px;
  }
  #compare-community-Modal .item-address h1 {
    font-size: 18px;
  }
  table.compare-table td {
    font-size: 15px;
    padding: 10px;
    vertical-align: top;
  }
  table.compare-table th {
    font-size: 15px;
    padding: 10px;
  }
  #compare-community-Modal.modal .modal-lg {
    margin: 0;
  }
  div.check-list-page ul.nav-tabs .nav-item .nav-link {
    padding: 10px 15px;
    font-size: 14px;
  }
  ul.help_ul.nav li .btn {
    padding: 6px 14px;
    font-size: 14px;
  }
  .resources-tab-view {
    width: 100%;
  }
  .calendar-view-page-schedule .fc .fc-daygrid-day-frame {
    min-height: 40px;
    height: 100%;
  }
  .fc .fc-daygrid-day.fc-day-today {
    height: 40px;
  }
  .city-landing-page.newOne .ulSlider {
    margin-left: 10px;
  }
} /*1199px*/

@media (min-width: 992px) {
  .tabSliders .owl-carousel .owl-stage-outer {
    max-width: 700px;
    margin: auto;
  }

  .tabSliders .owl-carousel .owl-stage {
    width: 100% !important;
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 700px;
    margin: auto;
    transform: initial !important;
  }

  .tabSliders .owl-carousel .owl-item {
    width: auto !important;
  }

  .tabSliders > .owl-carousel .owl-item {
  }
} /*992px*/

@media (max-width: 991px) {
  .city-landing-page.newOne .ulSlider {
    margin: auto;
  }
  .relonav-login .form-signin {
    max-width: 80%;
  }
  .relonav-login .input-group {
    width: 90%;
  }
  .relonav-login h1 {
    font-size: 30px;
    margin-top: 10px;
  }
  .relonav-login img {
    max-width: 90%;
  }
  .relonav-login .form-signin {
    margin-left: 20px;
    max-width: 80%;
  }
  .relo-dsLanding ul.consultant-details li a {
    font-size: 16px;
  }
  .relo-dsLanding ul.consultant-details li i {
    font-size: 25px;
    margin-right: 10px;
  }
  .relo-dsLanding .grid-view h1 {
    font-size: 25px;
  }
  .relo-dsLanding .grid-view h3 {
    font-size: 15px;
  }
  .relo-dsLanding .grid-view .item {
    padding: 15px;
  }
  .relo-dsLanding .grid-view {
    grid-column-gap: 15px;
    margin-top: 30px;
  }
  .relo-dsLanding .grid-view h3 a {
    font-size: 15px;
  }
  .relo-dsLanding ul.near-cities li a {
    padding: 5px 20px;
    font-size: 14px;
  }
  .relo-dsLanding .grid-view .item p {
    margin-top: 20px !important;
  }
  .ds-solo-profile .profile-main-div {
    grid-template-columns: 1fr 2fr;
  }
  .rightitems.list-priority-view {
    flex-wrap: wrap;
    height: auto;
    padding-top: 45px;
    overflow: hidden;
  }
  .list-priority-view {
    flex-wrap: wrap;
  }
  .width-60per,
  .width-70per,
  .width-80per {
    width: 90% !important;
  }
  .di_E_score_card_gridView .item h1 {
    font-size: 17px;
  }
  .city-landing-page .city-bg {
    margin-bottom: 20px;
  }
  .city-landing-page.newOne .col-md-4,
  .city-landing-page.newOne .col-md-8 {
    flex: auto;
    max-width: initial;
    width: 100%;
  }
  .weather-view-page .col-md-6 {
    width: 100%;
    flex: auto;
    max-width: initial;
  }
  .dssolonavbar.navbar {
    padding: 10px;
  }
  .dssolonavbar.navbar .navbar-toggler {
    border: 2px solid #ffffff;
  }
  .dssolonavbar.navbar .navbar-toggler-icon .svg-inline--fa {
    color: #ffffff;
  }
  .dssolonavbar.navbar .navbar-nav {
    padding: 0px 5px;
    margin-left: 0px !important;
    border-top: 1px solid #cccccc;
    width: 100%;
    padding-top: 10px;
    margin-top: 10px !important;
  }
  .dssolonavbar.navbar .navbar-collapse > div {
    flex-direction: column;
  }
  .city-landing-page.newOne .tabs-view ul.nav {
    top: 60px;
    justify-content: flex-start;
    padding-left: 15px;
  }
  div.new_modal_pop .modal-dialog.modal-lg {
    margin-top: 0;
  }
  div.city-landing-page .tabs-view ul.nav .nav-link {
    font-size: 14px;
    padding: 6px 10px;
  }
  .dssolonavbar.navbar .navbar-collapse {
    margin-right: 0px;
  }

  .dssolonavbar.navbar ul.navbar-nav.icon-uls {
    flex-direction: row;
    justify-content: flex-start;
    position: static;
  }
  #contact-us-modal-feedback .form-control.ant-select {
    width: 100%;
  }
  .tab-modal .widthModal {
    width: 90%;
  }
  .tab-modal .tails-row {
    grid-template-columns: repeat(1, 1fr);
  }

  .consultant-tails-tab .pd-tabs-view .nav-tabs .nav-link {
    padding: 8px 15px;
    font-size: 13px;
    margin-right: 8px;
    min-width: 80px;
  }
  .consultant-reports-data-select .col-md-10,
  .consultant-reports-data-select .col-md-2,
  .consultant-reports-data-select .col-md-3 {
    flex: auto;
    max-width: initial;
    width: 100%;
  }
  .tracker-view ul {
    width: 100%;
  }
  .city-landing-page .image img {
    height: 500px;
  }
  div.ds-profile-page .tabs-view ul.nav li .nav-link {
    font-size: 13px;
    padding: 6px 14px;
    margin-bottom: 10px;
  }

  div.city-landing-page .schools-btns .btn {
    font-size: 14px;
    padding: 6px 10px;
  }
  .my_properties_lists .trans-anttable table tr th:nth-child(2) {
    min-width: 300px;
  }

  #myModalAddActivity.modal .modal-dialog {
    width: 540px;
    max-width: initial;
  }
  #myModalAddActivity.modal .width-70per {
    width: 100% !important;
  }

  .consultant-report-views .col-10,
  .consultant-report-views .col-2 {
    width: 100%;
  }
  .consultant-report-views .col {
    flex: auto;
  }
  ul.help_ul.nav {
    flex-wrap: wrap;
  }
  ul.help_ul.nav li {
    margin-bottom: 10px;
  }
  .my_property_details.cityImage {
    height: 450px;
  }

  .city-landing-page.newOne.die-dataview .tabs-view ul.nav {
    justify-content: center;
    padding-left: 0;
  }
  div.city-landing-page.die-dataview .tabs-view ul.nav .nav-link {
    font-size: 14px;
    padding: 8px 20px;
  }

  .city-landing-page .city-bg {
    font-size: 18px;
  }
  .city-landing-page .city-bg.banner-text {
    display: none;
  }
  .city-landing-page .mobileView {
    display: block;
  }
  .city-landing-page .mobileView + .col-md-4 {
    margin-top: 1.5rem;
  }
  .city-landing-page .mobileView .city-bg.banner-text {
    display: block;
    margin-bottom: 0;
  }
  .city-landing-page.newOne h1.location {
    top: 67px;
    right: auto;
    left: 75px;
    background: #ededed;
    padding: 3px;
    border-radius: 5px;
    display: none;
  }
  .cityListDesclimber {
    width: 95%;
    font-size: 18px;
  }
  div.check-list-page .main-view {
    flex-direction: column-reverse;
    justify-content: flex-end;
  }
  .check-list-page .main-view .tabs-check {
    padding: 0;
  }
  .check-list-page .main-view .progress-view .image {
    margin-bottom: 1.5rem;
  }
  .trans-anttable .ant-table-thead > tr > th {
    min-width: 145px;
  }
  .tabPreferences .lis-view {
    width: 90%;
  }
  .explore-nearby-view.mapsearchbar form {
    width: 95%;
  }
  .resources-tab-view {
    width: 85%;
    margin: auto;
  }
  .resources-tab-view .botton-tab-view {
    grid-template-columns: repeat(3, 1fr);
  }
  .resources-tab-view .view-details {
    grid-template-columns: repeat(3, 1fr);
  }
  .resources-tab-view .tab-modal .widthModal {
    width: 95%;
  }
  .resources-tab-view .botton-tab-view .item {
    padding: 15px;
  }
  .resources-tab-view {
    width: 750px;
  }
  form ul.qualities li .btn {
    font-size: 14px;
    padding: 6px 15px;
  }
  div.ant-dropdown-placement-bottomLeft .ant-dropdown-menu li a {
    font-size: 16px;
    padding: 8px 20px;
    font-weight: 500;
    color: #333333 !important;
    display: block;
  }
  .calendar-view-page-schedule .fc .fc-daygrid-day-frame {
    min-height: 70px;
  }
  .fc .fc-daygrid-day.fc-day-today {
    height: 70px;
  }
  .city-landing-page .citylist {
    display: none;
  }
  .mobileCitylist {
    display: block;
  }

  /* .tabSliders > .owl-carousel .owl-item{
  width:200px !important;
} */
  h1.backBtn button {
    display: block;
  }
  .sharlotte-help-page h1 button.backBtn {
    display: block;
  }
  .di_E_main .map-pic svg {
    height: auto;
    margin-bottom: 30px;
  }

  .tabSliders .owl-carousel {
    position: static;
    box-shadow: none;
    width: 60%;
    margin: auto;
    margin-right: 0;
  }
  .tabSliders > .owl-carousel .owl-stage-outer {
    width: 100%;
  }
  .tabSliders {
    position: fixed;
    top: 55px;
    left: 0px;
    width: 100%;
    right: 0px;
    background: rgba(255, 255, 255, 0.85);
    box-shadow: 0px 0px 5px #959595;
    z-index: 9;
  }

  .corporateHousing_Updates {
    .p-request-form {
      .form-horizontal {
        width: 95%;
        max-width: 710px;
      }
    }
  }

  #PackingRecommendations {
    .modal-content .tails-row {
      column-count: auto;
    }
  }
} /*991px*/

@media (min-width: 768px) and (max-width: 991px) {
  .tabSliders .owl-carousel a.nav-item {
    padding: 8px 14px;
    font-size: 13px;
    width: 100%;
  }
}

@media (max-width: 767px) {
  @keyframes fadeInDown {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(0, 100%, 0);
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
    }
  }

  .new-drag-drop .list-priority-view .item,
  .new-drag-drop .list-priority-view {
    width: 100%;
  }

  .fadeInDown {
    -webkit-animation-name: fadeInDown;
    animation-name: fadeInDown;
  }
  .relo-dsLanding .grid-view {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 25px;
    max-width: 350px;
    margin: auto;
    width: 95%;
  }
  .footer_copyright ul.footer-ul-list::after {
    width: 100% !important;
  }

  .footer_copyright ul.footer-ul-list li {
    width: 45%;
  }
  .footer_copyright ul.footer-ul-list li a {
    margin: 10px;
  }
  .footer_copyright ul.footer-ul-list {
    flex-wrap: wrap;
    justify-content: space-between;
  }
  #add-check-list .px-5 {
    padding: 1rem !important;
  }

  #preference-modal.modal .modal-content,
  #add-property-modal.modal .modal-content {
    padding: 0px 20px;
  }
  .ds-solo-profile .profile-main-div {
    grid-gap: 30px;
    grid-template-columns: 1fr;
  }

  .my_properties_lists h1 span.cursor.add-list {
    margin: 15px 0px;
  }
  .my_properties_lists h1 span.cursor.add-list .btn {
    padding: 6px 15px;
  }
  .main_getStartedPage .bannerpart h1 {
    font-size: 2.5rem;
  }
  .main_getStartedPage .bannerpart h5 {
    font-size: 17px;
  }
  .main_getStartedPage {
    max-width: 95%;
    padding-bottom: 50px;
  }
  .main_getStartedPage .col-md-8 {
    max-width: 95%;
    flex: auto;
    padding: 30px;
  }
  .main_getStartedPage .col-md-8 .custom-checkbox {
    width: 100%;
  }
  .col-md-4 {
    position: relative;
    width: 100%;
    max-width: initial;
    flex: auto;
  }

  .city-landing-page.newOne .map-right-view {
    height: auto;
    top: auto;
    width: 95%;
    left: 0px;
    right: 0px;
    margin: auto;
    bottom: 0px;
  }
  .modal .city-landing-page.newOne .map-right-view {
    top: auto;
    height: auto;
  }

  .sharlotte-view .heightGrid .propertyresulttext {
    height: 100%;
  }

  #propertymap .city-landing-page.newOne .tabs-view ul.nav,
  #comparemap .city-landing-page.newOne .tabs-view ul.nav {
    top: 35px;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  #propertymap .city-landing-page .tabs-view ul.nav .nav-link,
  #comparemap .city-landing-page .tabs-view ul.nav .nav-link {
    font-size: 10px;
    padding: 6px 5px;
    margin-bottom: 10px;
    width: 27%;
    margin-right: 10px;
  }
  #propertymap .city-landing-page.newOne .relomap-height,
  #comparemap .city-landing-page.newOne .relomap-height {
    top: 0px;
    height: calc(100vh - 1px);
    min-height: initial;
  }
  div.new_modal_pop .modal-dialog.modal-lg {
    margin-top: 0px;
  }

  .city-landing-page.newOne .tabs-view ul.nav {
    padding: 10px 30px;
    justify-content: center;
    top: 60px;
  }
  .sharlotte-view .heightGrid .propertyresulttext {
    height: 100%;
  }

  div.city-landing-page .tabs-view ul.nav li {
    margin-bottom: 0px;
    width: auto;
  }

  div.city-landing-page.newOne .tabs-view ul.nav {
    flex-wrap: nowrap;
    top: 60px;
  }

  div.my_properties_lists .add-list .btn.theme-btn {
    font-size: 13px !important;
  }
  #compare-community-Modal.modal .modal-content {
    padding: 0px 20px;
  }

  #myModalDriversLicense.modal .modal-content {
    padding: 0px 0;
  }
  div.check-list-page .main-view .tabs-check .tab-content {
    margin-top: 0;
  }
  div.check-list-page .main-view .tabs-check {
    margin-top: 0;
  }
  div.city-landing-page.newOne .relomap-height {
    top: 108px;
    height: calc(100vh - 110px);
    margin: 0;
  }
  .consultant-tails-tab .pd-tabs-view .nav-tabs li {
    margin-bottom: 10px;
  }
  #edit-property-modal.modal .modal-content label {
    font-size: 14px;
  }
  #edit-property-modal.modal .modal-content {
    padding: 0px;
  }
  .ds-solo-profile .profile-main-div.notable {
    width: 90%;
  }
  .tracker-view ul li .text h3 {
    font-size: 13px;
  }

  .city-landing-page .image img {
    height: 400px;
  }
  .di_E_main {
    padding: 15px;
    margin-top: 15px;
  }
  .trans-anttable .table-top-input-btn {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }
  .usage_db .row-tails .card-body {
    width: 100%;
  }
  .usage_db_top_form {
    flex-wrap: wrap;
  }
  .usage_db_top_form.focus-input-label .floating-label {
    width: 100%;
    margin-bottom: 10px;
  }
  .dashboard-ds .col-md-8 {
    flex: auto;
    max-width: initial;
  }
  .my_properties_lists .main_grid .item .content {
    padding: 10px 15px;
  }
  .my_properties_lists .main_grid .item p {
    min-height: initial;
    margin-bottom: 10px;
  }
  .my_properties_lists .main_grid {
    grid-gap: 20px;
  }
  ul.help_ul.nav {
    flex-wrap: wrap;
  }
  .mAppView + div .resources-tab-view > h1 {
    font-size: 30px;
    font-weight: 600;
    padding: 15px 0;
    margin: 0;
    display: block;
    background: #ffffff;
    position: fixed;
    left: 0px;
    right: 0px;
    top: 20px;
  }
  .mAppView + div .resources-tab-view > p {
    margin-top: 95px;
  }
  ul.help_ul.nav li .btn {
    padding: 6px 9px;
    font-size: 14px;
    margin-right: 10px;
  }
  .sharlotte-help-page .view {
    padding: 15px;
  }
  .my_property_details.cityImage {
    height: 350px;
  }
  div.submit-download-view .item {
    margin: 30px auto;
  }
  .resources-tab-view {
    width: 95%;
    margin: auto;
  }

  .resources-tab-view .view-details .item-image {
    width: auto;
    height: auto;
    min-width: 50px;
    margin: 0;
    margin-right: 10px;
  }

  .resources-tab-view .view-details img {
    width: 50px;
  }

  .resources-tab-view .view-details .item {
    padding: 15px 10px;
    display: flex;
    border-radius: 7px;
    align-items: center;
    cursor: pointer;
  }
  .resources-tab-view .view-details p {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 0px;
    text-align: left;
  }

  .resources-tab-view .view-details .btn {
    display: none;
  }
  .resources-tab-view h2 {
    font-weight: 600;
    font-size: 1.5rem;
  }
  .resources-tab-view .botton-tab-view .item {
    padding: 15px 10px;
    display: flex;
    border-radius: 7px;
    align-items: center;
  }
  .resources-tab-view .botton-tab-view .item span {
    width: auto;
    height: auto;
    min-width: 40px;
    margin: 0;
    margin-right: 10px;
  }
  .resources-tab-view .botton-tab-view .item img {
    width: 40px !important;
  }
  .resources-tab-view .botton-tab-view .item h3 {
    font-size: 15px;
    text-align: left;
    min-height: initial;
    white-space: normal;
    word-break: break-word;
    width: 100%;
    margin-top: 0;
  }

  .resources-tab-view .tab-modal .tails-row {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 0;
  }
  .resources-tab-view .botton-tab-view {
    grid-template-columns: repeat(2, 1fr);
  }
  .resources-tab-view .view-details {
    grid-template-columns: repeat(2, 1fr);
  }
  .resources-tab-view {
    width: 90%;
  }
  form ul.qualities {
    flex-wrap: wrap;
  }
  form ul.qualities li {
    margin-bottom: 15px;
  }
  .relo-step-from .two-tails {
    flex-wrap: wrap;
  }
  .relo-step-from .two-tails .form-group {
    width: 100%;
  }
  #compare-community-Modal .modal-header .close {
    position: absolute;
    top: 10px;
    right: 15px;
  }
  #compare-community-Modal .modal-header .item {
    display: block !important;
  }
  #compare-community-Modal .modal-header {
    flex-direction: column-reverse;
    justify-content: flex-start;
    align-items: flex-start;
  }
  div#compare-community-Modal .modal-header .btn {
    padding-left: 0;
  }
  .di_E_score_card_gridView .item {
    min-height: 250px;
    padding: 0;
  }
  .die-dataview .relomap-height .gmnoprint.gm-style-mtc-bbw {
    top: 0px !important;
  }
  .religious_mainView div#mapus {
    top: 105px;
  }
  p.nodataFound {
    display: flex;
    height: calc(100% - 110px);
    justify-content: center;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px;
    width: 80%;
    margin: auto;
  }
  .relomap-height .gmnoprint {
    top: 30px;
  }

  .religious_mainView div#mapus .gmnoprint {
    top: 0px;
    left: auto !important;
    right: 0px;
    top: 75px;
  }
  button.gm-svpc {
    display: none;
  }
  .modal .city-landing-page.newOne .heightGrid {
    height: calc(100vh - 230px);
  }
  .modal .city-landing-page.newOne .full + .heightGrid {
    height: 150px;
  }
  .calendar-view-page-schedule .fc .fc-daygrid-day-frame {
    min-height: 50px;
  }
  .fc .fc-daygrid-day.fc-day-today {
    height: 50px;
  }
  .city-landing-page .amenities ul li {
    font-size: 14px;
  }
  .city-landing-page .amenities ul li img {
    width: 25px;
    margin-right: 5px;
  }
  .city-landing-page .tabs-view {
    padding-top: 20px;
  }
  .city-landing-page.propertyDetails .tabs-view {
    padding-top: 0;
  }
  .city-landing-page.propertyDetails header {
    padding-top: 30px;
  }

  .tabs-view .tab-content {
    padding-top: 10px;
  }

  .tabSliders .owl-carousel a.nav-item {
    padding: 8px 15px;
    font-size: 14px;
    width: 100%;
  }
  .city-landing-page.newOne h1.backBtn button {
    top: 73px;
    left: 10px;
    background: #ffffff;
    color: #000;
    border: 2px solid #ffffff;
    font-weight: 600;
    /* border: 1px solid #837f7f; */
  }
  .map-right-view .slider .item a {
    min-width: initial;
  }

  /* .explore-nearby-view.mapsearchbar {
    padding-bottom: 20px;
  } */
  /* .explore-nearby-view.mapsearchbar form{
    margin-top: 15px;
  } */
  .city-landing-page .tabs-view #overview {
    margin-top: 20px;
  }
  .city-landing-page.newOne .mapsearchbar + h1 + h1 + div .heightGrid {
    height: calc(100vh - 260px);
  }
  .city-landing-page.newOne .mapsearchbar + h1 + h1 + div .full + .heightGrid {
    height: 150px;
  }
  h1.backBtn button {
    display: flex;
  }
  .city-landing-page.newOne .heightGrid {
    height: 50px;
  }
  .city-landing-page.newOne .full + .heightGrid {
    height: calc(100vh - 190px);
  }
  /* .tabSliders > .owl-carousel .owl-item {
    width: 160px !important;
  } */
  /* .tabSliders > .owl-carousel .owl-stage-outer {
    width: calc(100% - 70px);
    margin-top: 6px;
} */

  .main_getStartedPage .bannerpart {
    padding: 20px 0;
  }

  .corporateHousing_Updates {
    .p-request-form {
      .form-horizontal {
        padding: 30px;
      }
    }
  }
  .ds-solo-profile .profile-main-div p.note {
    grid-column: auto;
  }

  .tabSliders .owl-carousel.owl-drag .owl-item {
    width: auto !important;
  }
  .tabSliders .owl-carousel .owl-stage {
    width: 750px !important;
  }

  .tabSliders .owl-carousel {
    width: calc(100% - 300px);
  }
  .tabSliders .owl-carousel.owl-drag .owl-item:last-child {
    margin-right: 60px !important;
  }

  .tabSliders .owl-carousel.owl-drag .owl-item {
    margin-right: 12px !important;
  }
  .ds-solo-profile .content {
    padding: 20px;
  }

  .map-right-view .owl-carousel .owl-item {
    width: auto !important;
  }

  .calendar-view-page-schedule .fc-event {
    bottom: -25px;
  }
  .calendar-view-page-schedule .main-view .item .bg-color {
    padding: 10px 15px;
  }

  .resources-tab-view .text-box {
    margin: 10px 0px 20px;
  }
  .resources-tab-view .text-box p {
    font-size: 16px;
  }
  .resources-tab-view > p {
    background: #e3e3e3;
    padding: 15px;
    border-radius: 7px;
    font-size: 16px;
  }

  .resources-tab-view > h1 {
    text-align: center;
    font-size: 25px;
    font-weight: 700;
    margin-top: -20px;
  }

  .custommultiCheckBox #multi-rest i.fa.fa-angle-right {
    width: 25px;
    position: absolute;
    top: 15px;
    right: -25px;
    background: #d7c7fa;
    height: 40px;
    font-size: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0px 5px 5px 0;
    cursor: pointer;
  }

  .custommultiCheckBox #multi-rest {
    background: transparent;
    width: 0;
    left: -55px;
    .filterIcon {
      width: 40px;
      position: absolute;
      top: 14px;
      right: -37px;
      background: #d7c7fa;
      height: 50px;
      font-size: 17px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0px 5px 5px 0;
      cursor: pointer;
      padding: 3px 10px 3px 10px;
      img {
        width: 100%;
      }
    }
  }

  .custommultiCheckBox #multi-rest .textView {
    display: none;
    width: 0;
  }
  .custommultiCheckBox #multi-rest.active {
    background: #ffffff;
    width: 300px;
    left: 0;
    .filterIcon {
      font-size: 18px;
      right: 0px;
      background: transparent;
      top: -5px;
      &::before {
        content: "\\f05c";
        content: "\\f00d";
        font-family: FontAwesome;
        position: absolute;
        right: 0px;
        top: 0px;
        left: 0px;
        margin: auto;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      img {
        display: none;
      }
    }

    .textView {
      width: auto;
      display: block;
    }
  }

  .custommultiCheckBox #multi-rest.active .fa-angle-right:before {
    transform: rotate(-180deg);
  }
  .check-list-page .main-view {
    margin-top: 75px;
  }
  .check-list-page ul.nav-tabs.scroll-ul {
    top: 40px;
  }
  .check-list-page {
    padding-top: 10px;
  }
  div.check-list-page ul.nav-tabs .nav-item .nav-link {
    padding: 6px 13px;
    font-size: 14px;
    min-width: 70px;
  }
  .check-list-page .top-task-btns a.task:hover {
    background: transparent;
  }
  .check-list-page .top-task-btns {
    top: 5px;
    display: flex;
    a.task {
      background: transparent;
      border: 0;
      margin-right: 0;
      padding: 0;
      margin-left: 10px;
      span {
        display: none;
      }
      img {
        display: block;
      }
      .bi {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: #d7c7fa;
        font-size: 23px;
      }
      .bi-plus::before {
        font-weight: 600 !important;
      }
    }
  }

  .explore-nearby-view.mapsearchbar {
    position: absolute;
    right: 0;
    padding: 0;
    margin: 0;
    top: 170px;
    & > span {
      background: #d7c7fa;
      font-size: 16px;
      position: absolute;
      right: 10px;
      z-index: 9;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 8px;
      i.fa.fa-search {
        display: block;
      }
    }
    & > span:has(+ .active) {
      background: #ffffff;
      padding-top: 15px;
      top: 10px;
      z-index: 9999;
      i::before {
        content: "\\f00d";
      }
    }

    form {
      display: none;
      &.active {
        display: block;
        width: 350px;
        right: 0px;
        position: relative;
        background: #ffffff;
        padding: 15px 15px;
        width: 100vw;
        left: 0;
        top: 0;
      }
      input {
        background: #f2f2f2;
        padding-left: 17px;
      }
    }
    .input-group {
      width: 90%;
      margin: auto;
    }
    .btn.btn-default {
      display: flex;
      align-items: center;
      height: 100%;
      color: #000;
      padding: 8px 14px 8px 11px;
      b {
        display: none;
      }
      i.fa.fa-search {
        display: block !important;
        color: #000000;
        position: static;
      }
    }
    i.fa.fa-search {
      display: none;
    }

    &.overview {
      position: relative;
      padding-bottom: 60px;
      margin-top: 45px;
      top: 8px;
      & > span {
        display: none;
      }
      form {
        display: block;
      }
    }
    &.transit {
      top: 125px;
    }
    &.schools {
      top: 250px;
    }
  }

  #transit .communityNew-publictransitapp.citybg {
    display: block;
    position: relative;
    width: 100%;
    height: calc(100vh - 110px);
    .isochronestyles {
      top: 40px;
      left: -290px;
      transition: all 0.05s;
      &.active {
        left: 10px;
      }
      i.fa.fa-times {
        position: absolute;
        right: 20px;
        top: 16px;
        cursor: pointer;
        font-size: 20px;
        display: block !important;
      }
    }
    .filterIcon {
      width: 40px;
      position: absolute;
      top: 40px;
      left: 0px;
      background: #d7c7fa;
      height: 50px;
      font-size: 17px;
      display: flex !important;
      align-items: center;
      justify-content: center;
      border-radius: 0px 5px 5px 0;
      cursor: pointer;
      padding: 3px 10px 3px 10px;

      img {
        width: 100%;
      }
      &.active {
        background: transparent;
        img {
          display: none;
        }
      }
    }
  }
} /*767px*/

@media (max-width: 639px) {
  .city-landing-page.newOne h1.location {
    display: none;
  }
  .tabSliders .owl-carousel {
    width: calc(100% - 75px);
  }
  .tabSliders .owl-carousel .owl-stage {
    width: 550px !important;
  }
}

@media (max-width: 575px) {
  .relonav-login .form-signin {
    max-width: 80%;
    background: #ffffff;
    border-radius: 10px;
    padding: 30px;
    margin: auto;
    position: fixed;
    left: 0px;
    right: 0px;
    bottom: 35px;
  }
  .relonav-login .item {
    display: block;
    width: auto;
    height: auto;
  }
  .relonav-login .item img.logoBanner {
    height: 100vh;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0;
  }
  .relonav-login img {
    max-width: 100%;
    height: auto;
  }
  .relonav-login h1 + span {
    font-size: 15px;
  }
  .weather-view-page .weather-view-sub-details ul li {
    padding: 0px 10px;
  }
  .weather-view-page .weather-view-sub-details ul li img {
    height: 25px;
  }
  .weather-view-page .weather-view-sub-details ul li span {
    font-size: 15px;
    padding-left: 10px;
  }
  .weather-view-page .weather-view-sub-details ul li p {
    font-size: 15px;
    padding-left: 0;
    margin-bottom: 0;
  }
  .weather-view-page .weather-view-week-details .item {
    width: 30%;
  }
  .weather-view-page .weather-view-week-details .item p {
    font-size: 25px;
    font-weight: 800;
  }
  .weather-view-page .weather-view-week-details .item img {
    height: 70px;
  }
  .weather-view-page .weather-view-week-details .item span {
    font-size: 15px;
    font-weight: 600;
  }
  div.city-landing-page.newOne .tabs-view ul.nav {
    padding: 10px 5px;
  }
  div.city-landing-page.newOne .tabs-view ul.nav .nav-link {
    font-size: 9px;
    padding: 6px 20px;
    margin: 0;
    margin-right: 8px;
  }
  div.city-landing-page.die-dataview .tabs-view ul.nav .nav-link {
    font-size: 14px;
    padding: 6px 14px;
    margin: 0;
    margin-right: 8px;
  }

  div.city-landing-page.newOne .tabs-view ul.nav li:last-child .nav-link {
    margin: 0;
  }
  .city-landing-page .image img {
    height: 250px;
  }

  #myModalAddActivity.modal .modal-dialog {
    width: 100%;
    max-width: initial;
  }

  .my_properties_lists h1 {
    align-items: center;
  }
  .main_getStartedPage .formView h1 a.help {
    display: block;
    margin: 0;
    margin-top: 5px;
  }
  .my_property_details.cityImage {
    height: 250px;
  }
  .my_properties_lists h1.main {
    flex-direction: column;
    align-items: flex-start;
  }
  #myModalAddActivity .checbox-label {
    margin-top: 0;
    margin-bottom: 15px;
  }
  .modal-fullscreen {
    padding: 0 !important;
  }
  .modal-fullscreen .modal-dialog {
    width: 100%;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen .modal-body {
    overflow-y: auto;
  }

  .resources-tab-view {
    width: 95%;
    margin: auto;
  }

  .resources-tab-view .botton-tab-view .btn {
    font-size: 17px;
    padding: 10px 10px;
  }
  #propertymap .city-landing-page .tabs-view ul.nav .nav-link,
  #comparemap .city-landing-page .tabs-view ul.nav .nav-link {
    width: 30%;
  }
  .modal .tabs-view ul.nav .nav-link a {
    font-size: 12px;
  }
  #propertymap.modal.new_modal_pop .pointer.close,
  #comparemap .modal.new_modal_pop .pointer.close {
    top: 10px;
  }
  .my_properties_lists h1 span.cursor.add-list .btn {
    padding: 6px 12px;
  }
  .calendar-view-page-schedule .fc .fc-daygrid-day-frame {
    min-height: initial;
  }
  .fc .fc-daygrid-day.fc-day-today {
    height: 50px;
  }
  .fc .fc-view-harness {
    height: 300px !important;
  }
  .btn.theme-btn {
    padding: 7px 17px;
  }
  .main_getStartedPage .bannerpart h1 {
    font-size: 27px;
  }
  .main_getStartedPage .bannerpart h5 {
    font-size: 15px;
  }
  .custom-file-upimg_multy {
    flex-wrap: wrap;
  }
  #compare-community-Modal .item-address h1 {
    font-size: 18px;
    align-items: flex-start;
  }
  .main_getStartedPage .checkbtns .btn {
    padding: 5px 20px;
    font-size: 14px;
  }
  .main_getStartedPage .col-md-8 {
    max-width: 100%;
    padding: 20px;
  }
  input#address {
    font-size: 14px;
  }
  .weather-view-page .weather-view-main-details .fa-clouds {
    font-size: 65px;
  }
  .weather-view-page .weather-view-main-details span {
    font-size: 3rem;
  }
  .weather-view-page .weather-view-main-details p {
    font-size: 18px;
  }
  .city-landing-page .amenities ul li {
    font-size: 14px;
    min-width: initial;
    width: 50%;
  }

  .help-Modal-box .modal-dialog {
    width: 95%;
    margin: 30px auto;
  }
  .help-Modal-box .modal-content h1 span {
    font-size: 2rem;
  }
  .help-Modal-box .modal-content .letsstart {
    font-size: 3rem;
    line-height: 1.5;
    text-align: left;
    margin: 50px 0;
  }

  .tabSliders .owl-carousel .item {
    text-align: center;
  }
  .tabSliders .owl-carousel a.nav-item {
    /* width: 95%;
    padding: 8px 8px; */
  }
  /* .tabSliders > .owl-carousel .owl-item {
    width: min-content !important;
    min-width: 130px;
  }
  .tabSliders .owl-carousel a.nav-item{
    display: inline-block;
    width: 90%;
    margin: auto;
  } */
} /*575px*/

@media (max-width: 400px) {
  div.city-landing-page.die-dataview .tabs-view ul.nav .nav-link {
    font-size: 13px;
    padding: 6px 13px;
  }
  .my_properties_lists h1 span.cursor.add-list .btn {
    padding: 6px 9px;
  }
  .check-list-page .top_label-div > span {
    min-width: 120px;
    align-items: center;
  }
  .listViewOnMap_school {
    max-width: 335px;
    .subnew {
      .item {
        a {
          font-size: 13px;
        }
      }
    }
  }
  .chat_width .modal-content {
    padding: 25px;
  }
  .alternate-user-modal.myModalconfirmdes .modal-password-content,
  .ds-profile-page .chat_msgs .left_chat_view,
  .ds-profile-page .chat_msgs .right_chat_view {
    width: 95%;
  }
  .chat_footer-fullview .chat_msgs .right_chat {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./public/assets/css/resposive.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,YAAY;IACZ,aAAa;EACf;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;AACF,EAAE,SAAS;;AAEX;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,8BAA8B;EAChC;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,mBAAmB;EACrB;AACF,EAAE,SAAS;AACX;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;AACF,EAAE,SAAS;;AAEX;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;EACA;AACF,EAAE,QAAQ;;AAEV;EACE;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;;;IAGE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,UAAU;IACV,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,6BAA6B;IAC7B,WAAW;IACX,iBAAiB;IACjB,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,SAAS;IACT,2BAA2B;IAC3B,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;EACA;;;IAGE,UAAU;IACV,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,yBAAyB;EAC3B;EACA;IACE,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;;EAEA;;GAEC;EACD;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,SAAS;IACT,SAAS;IACT,WAAW;IACX,UAAU;IACV,qCAAqC;IACrC,+BAA+B;IAC/B,UAAU;EACZ;;EAEA;IACE;MACE;QACE,UAAU;QACV,gBAAgB;MAClB;IACF;EACF;;EAEA;IACE;MACE,kBAAkB;IACpB;EACF;AACF,EAAE,QAAQ;;AAEV;EACE;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE;IACE;MACE,UAAU;MACV,0CAA0C;MAC1C,kCAAkC;IACpC;;IAEA;MACE,UAAU;MACV,gCAAgC;MAChC,wBAAwB;IAC1B;EACF;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;EACA;IACE,qCAAqC;IACrC,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,UAAU;EACZ;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,UAAU;IACV,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,UAAU;IACV,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;EACb;EACA;IACE,SAAS;IACT,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,SAAS;IACT,2BAA2B;IAC3B,eAAe;EACjB;EACA;;IAEE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;EACpB;EACA;;IAEE,QAAQ;IACR,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,2BAA2B;IAC3B,SAAS;EACX;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,UAAU;IACV,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,WAAW;EACb;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,YAAY;EACd;EACA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;IACR,qBAAqB;IACrB,UAAU;IACV,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;EACA;IACE,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,+BAA+B;EACjC;EACA;IACE,kBAAkB;EACpB;;EAEA;;KAEG;EACH;;KAEG;EACH;IACE,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,2BAA2B;EAC7B;EACA;;KAEG;EACH;;;GAGC;;EAED;IACE,eAAe;EACjB;;EAEA;IACE;MACE;QACE,aAAa;MACf;IACF;EACF;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;EACA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;IAC5B,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX;MACE,WAAW;MACX,kBAAkB;MAClB,SAAS;MACT,YAAY;MACZ,mBAAmB;MACnB,YAAY;MACZ,eAAe;MACf,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,4BAA4B;MAC5B,eAAe;MACf,0BAA0B;MAC1B;QACE,WAAW;MACb;IACF;EACF;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,mBAAmB;IACnB,YAAY;IACZ,OAAO;IACP;MACE,eAAe;MACf,UAAU;MACV,uBAAuB;MACvB,SAAS;MACT;QACE,gBAAgB;QAChB,gBAAgB;QAChB,wBAAwB;QACxB,kBAAkB;QAClB,UAAU;QACV,QAAQ;QACR,SAAS;QACT,YAAY;QACZ,SAAS;QACT,aAAa;QACb,uBAAuB;QACvB,mBAAmB;MACrB;MACA;QACE,aAAa;MACf;IACF;;IAEA;MACE,WAAW;MACX,cAAc;IAChB;EACF;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,QAAQ;IACR,aAAa;IACb;MACE,uBAAuB;MACvB,SAAS;MACT,eAAe;MACf,UAAU;MACV,iBAAiB;MACjB;QACE,aAAa;MACf;MACA;QACE,cAAc;MAChB;MACA;QACE,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;MACjB;MACA;QACE,2BAA2B;MAC7B;IACF;EACF;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,SAAS;IACT,UAAU;IACV;MACE,mBAAmB;MACnB,eAAe;MACf,kBAAkB;MAClB,WAAW;MACX,UAAU;MACV,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,iBAAiB;MACjB;QACE,cAAc;MAChB;IACF;IACA;MACE,mBAAmB;MACnB,iBAAiB;MACjB,SAAS;MACT,aAAa;MACb;QACE,gBAAgB;MAClB;IACF;;IAEA;MACE,aAAa;MACb;QACE,cAAc;QACd,YAAY;QACZ,UAAU;QACV,kBAAkB;QAClB,mBAAmB;QACnB,kBAAkB;QAClB,YAAY;QACZ,OAAO;QACP,MAAM;MACR;MACA;QACE,mBAAmB;QACnB,kBAAkB;MACpB;IACF;IACA;MACE,UAAU;MACV,YAAY;IACd;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ,WAAW;MACX,0BAA0B;MAC1B;QACE,aAAa;MACf;MACA;QACE,yBAAyB;QACzB,cAAc;QACd,gBAAgB;MAClB;IACF;IACA;MACE,aAAa;IACf;;IAEA;MACE,kBAAkB;MAClB,oBAAoB;MACpB,gBAAgB;MAChB,QAAQ;MACR;QACE,aAAa;MACf;MACA;QACE,cAAc;MAChB;IACF;IACA;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,2BAA2B;IAC3B;MACE,SAAS;MACT,YAAY;MACZ,qBAAqB;MACrB;QACE,UAAU;MACZ;MACA;QACE,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,eAAe;QACf,eAAe;QACf,yBAAyB;MAC3B;IACF;IACA;MACE,WAAW;MACX,kBAAkB;MAClB,SAAS;MACT,SAAS;MACT,mBAAmB;MACnB,YAAY;MACZ,eAAe;MACf,wBAAwB;MACxB,mBAAmB;MACnB,uBAAuB;MACvB,4BAA4B;MAC5B,eAAe;MACf,0BAA0B;;MAE1B;QACE,WAAW;MACb;MACA;QACE,uBAAuB;QACvB;UACE,aAAa;QACf;MACF;IACF;EACF;AACF,EAAE,QAAQ;;AAEV;EACE;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,SAAS;IACT,UAAU;IACV,YAAY;EACd;EACA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,SAAS;IACT,QAAQ;EACV;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,SAAS;IACT,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,SAAS;IACT,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,SAAS;EACX;EACA;IACE,YAAY;IACZ,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;;IAEE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;;IAEE,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE;uBACmB;EACrB;EACA;;;;;;;;KAQG;AACL,EAAE,QAAQ;;AAEV;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB;MACE;QACE;UACE,eAAe;QACjB;MACF;IACF;EACF;EACA;IACE,aAAa;EACf;EACA;;;IAGE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["@media (min-width: 3000px) {\r\n  .fc .fc-daygrid-day.fc-day-today {\r\n    height: 120px;\r\n  }\r\n}\r\n@media (min-width: 2000px) {\r\n  .fc .fc-daygrid-day.fc-day-today {\r\n    height: 100px;\r\n  }\r\n  .dssolonavbar.navbar .navbar-nav .nav-link {\r\n    padding: 8px 15px;\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n@media (max-width: 1600px) {\r\n  #compare-community-Modal .item-address {\r\n    margin-right: 0px;\r\n    width: 100%;\r\n  }\r\n  .relonav-login .form-signin {\r\n    margin-left: 10%;\r\n  }\r\n  #compare-community-Modal .item-address img {\r\n    border-radius: 10px;\r\n    width: 160px;\r\n    height: 100px;\r\n  }\r\n  #compare-community-Modal .item-address h2 {\r\n    font-size: 17px;\r\n    max-width: 90%;\r\n  }\r\n  #compare-community-Modal .item-address h1 {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n  }\r\n  table.compare-table td {\r\n    font-size: 17px;\r\n  }\r\n  table.compare-table th {\r\n    font-size: 17px;\r\n    min-width: 200px;\r\n  }\r\n  .dssolonavbar.navbar .navbar-nav .nav-link {\r\n    padding: 8px 10px;\r\n  }\r\n\r\n  .calendar-view-page-schedule .fc .fc-daygrid-day-frame {\r\n    min-height: 60px;\r\n  }\r\n  .calendar-view-page-schedule .fc-view-harness.fc-view-harness-active {\r\n    min-height: 450px;\r\n  }\r\n} /*1600px*/\r\n\r\n@media (max-width: 1366px) {\r\n  .relonav-login h1 {\r\n    font-size: 40px;\r\n    margin-top: 25px;\r\n    margin-bottom: 0rem !important;\r\n  }\r\n  .relonav-login img {\r\n    height: 40px;\r\n  }\r\n  .relonav-login .form-signin img {\r\n    height: auto;\r\n    max-width: 100%;\r\n  }\r\n  .relonav-login .btn.btn-dark {\r\n    font-size: 15px;\r\n  }\r\n  .relo-dsLanding .grid-view h1 {\r\n    font-size: 2rem;\r\n  }\r\n  .my_properties_lists .main_grid .item p {\r\n    font-size: 13px;\r\n  }\r\n  .dssolonavbar.navbar .navbar-nav .nav-link {\r\n    padding: 8px 5px;\r\n    font-size: 15px;\r\n  }\r\n  .city-landing-page.newOne .tabs-view ul.nav {\r\n    top: 47px;\r\n  }\r\n  .dssolonavbar.navbar .navbar-collapse {\r\n    margin-right: 160px;\r\n  }\r\n} /*1366px*/\r\n@media (max-width: 1199px) {\r\n  .relo-step-from form {\r\n    width: 100%;\r\n    padding: 25px 30px;\r\n  }\r\n  .relo-step-from .tracker-view {\r\n    width: 100%;\r\n  }\r\n  .relo-step-from form label {\r\n    font-size: 16px;\r\n  }\r\n  .weather-view-page .weather-view-main-details span {\r\n    font-size: 3.5rem;\r\n  }\r\n  .weather-view-page .weather-view-main-details .fa-clouds {\r\n    font-size: 80px;\r\n  }\r\n  .weather-view-page {\r\n    padding-left: 0;\r\n  }\r\n  .weather-view-page .weather-view-week-details .item {\r\n    width: 115px;\r\n    margin: auto;\r\n  }\r\n\r\n  .dssolonavbar.navbar .navbar-nav:first-child .nav-item {\r\n    padding: 0;\r\n  }\r\n\r\n  .dssolonavbar.navbar .navbar-nav .nav-link {\r\n    font-size: 12px;\r\n    padding: 8px 0px;\r\n    margin: 0 8px;\r\n    display: inline-block;\r\n  }\r\n  .dssolonavbar.navbar .navbar-collapse {\r\n    margin-right: 120px;\r\n  }\r\n\r\n  #compare-community-Modal .item-address h2 {\r\n    font-size: 14px;\r\n  }\r\n  #compare-community-Modal .item-address h1 {\r\n    font-size: 18px;\r\n  }\r\n  table.compare-table td {\r\n    font-size: 15px;\r\n    padding: 10px;\r\n    vertical-align: top;\r\n  }\r\n  table.compare-table th {\r\n    font-size: 15px;\r\n    padding: 10px;\r\n  }\r\n  #compare-community-Modal.modal .modal-lg {\r\n    margin: 0;\r\n  }\r\n  div.check-list-page ul.nav-tabs .nav-item .nav-link {\r\n    padding: 10px 15px;\r\n    font-size: 14px;\r\n  }\r\n  ul.help_ul.nav li .btn {\r\n    padding: 6px 14px;\r\n    font-size: 14px;\r\n  }\r\n  .resources-tab-view {\r\n    width: 100%;\r\n  }\r\n  .calendar-view-page-schedule .fc .fc-daygrid-day-frame {\r\n    min-height: 40px;\r\n    height: 100%;\r\n  }\r\n  .fc .fc-daygrid-day.fc-day-today {\r\n    height: 40px;\r\n  }\r\n  .city-landing-page.newOne .ulSlider {\r\n    margin-left: 10px;\r\n  }\r\n} /*1199px*/\r\n\r\n@media (min-width: 992px) {\r\n  .tabSliders .owl-carousel .owl-stage-outer {\r\n    max-width: 700px;\r\n    margin: auto;\r\n  }\r\n\r\n  .tabSliders .owl-carousel .owl-stage {\r\n    width: 100% !important;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    max-width: 700px;\r\n    margin: auto;\r\n    transform: initial !important;\r\n  }\r\n\r\n  .tabSliders .owl-carousel .owl-item {\r\n    width: auto !important;\r\n  }\r\n\r\n  .tabSliders > .owl-carousel .owl-item {\r\n  }\r\n} /*992px*/\r\n\r\n@media (max-width: 991px) {\r\n  .city-landing-page.newOne .ulSlider {\r\n    margin: auto;\r\n  }\r\n  .relonav-login .form-signin {\r\n    max-width: 80%;\r\n  }\r\n  .relonav-login .input-group {\r\n    width: 90%;\r\n  }\r\n  .relonav-login h1 {\r\n    font-size: 30px;\r\n    margin-top: 10px;\r\n  }\r\n  .relonav-login img {\r\n    max-width: 90%;\r\n  }\r\n  .relonav-login .form-signin {\r\n    margin-left: 20px;\r\n    max-width: 80%;\r\n  }\r\n  .relo-dsLanding ul.consultant-details li a {\r\n    font-size: 16px;\r\n  }\r\n  .relo-dsLanding ul.consultant-details li i {\r\n    font-size: 25px;\r\n    margin-right: 10px;\r\n  }\r\n  .relo-dsLanding .grid-view h1 {\r\n    font-size: 25px;\r\n  }\r\n  .relo-dsLanding .grid-view h3 {\r\n    font-size: 15px;\r\n  }\r\n  .relo-dsLanding .grid-view .item {\r\n    padding: 15px;\r\n  }\r\n  .relo-dsLanding .grid-view {\r\n    grid-column-gap: 15px;\r\n    margin-top: 30px;\r\n  }\r\n  .relo-dsLanding .grid-view h3 a {\r\n    font-size: 15px;\r\n  }\r\n  .relo-dsLanding ul.near-cities li a {\r\n    padding: 5px 20px;\r\n    font-size: 14px;\r\n  }\r\n  .relo-dsLanding .grid-view .item p {\r\n    margin-top: 20px !important;\r\n  }\r\n  .ds-solo-profile .profile-main-div {\r\n    grid-template-columns: 1fr 2fr;\r\n  }\r\n  .rightitems.list-priority-view {\r\n    flex-wrap: wrap;\r\n    height: auto;\r\n    padding-top: 45px;\r\n    overflow: hidden;\r\n  }\r\n  .list-priority-view {\r\n    flex-wrap: wrap;\r\n  }\r\n  .width-60per,\r\n  .width-70per,\r\n  .width-80per {\r\n    width: 90% !important;\r\n  }\r\n  .di_E_score_card_gridView .item h1 {\r\n    font-size: 17px;\r\n  }\r\n  .city-landing-page .city-bg {\r\n    margin-bottom: 20px;\r\n  }\r\n  .city-landing-page.newOne .col-md-4,\r\n  .city-landing-page.newOne .col-md-8 {\r\n    flex: auto;\r\n    max-width: initial;\r\n    width: 100%;\r\n  }\r\n  .weather-view-page .col-md-6 {\r\n    width: 100%;\r\n    flex: auto;\r\n    max-width: initial;\r\n  }\r\n  .dssolonavbar.navbar {\r\n    padding: 10px;\r\n  }\r\n  .dssolonavbar.navbar .navbar-toggler {\r\n    border: 2px solid #ffffff;\r\n  }\r\n  .dssolonavbar.navbar .navbar-toggler-icon .svg-inline--fa {\r\n    color: #ffffff;\r\n  }\r\n  .dssolonavbar.navbar .navbar-nav {\r\n    padding: 0px 5px;\r\n    margin-left: 0px !important;\r\n    border-top: 1px solid #cccccc;\r\n    width: 100%;\r\n    padding-top: 10px;\r\n    margin-top: 10px !important;\r\n  }\r\n  .dssolonavbar.navbar .navbar-collapse > div {\r\n    flex-direction: column;\r\n  }\r\n  .city-landing-page.newOne .tabs-view ul.nav {\r\n    top: 60px;\r\n    justify-content: flex-start;\r\n    padding-left: 15px;\r\n  }\r\n  div.new_modal_pop .modal-dialog.modal-lg {\r\n    margin-top: 0;\r\n  }\r\n  div.city-landing-page .tabs-view ul.nav .nav-link {\r\n    font-size: 14px;\r\n    padding: 6px 10px;\r\n  }\r\n  .dssolonavbar.navbar .navbar-collapse {\r\n    margin-right: 0px;\r\n  }\r\n\r\n  .dssolonavbar.navbar ul.navbar-nav.icon-uls {\r\n    flex-direction: row;\r\n    justify-content: flex-start;\r\n    position: static;\r\n  }\r\n  #contact-us-modal-feedback .form-control.ant-select {\r\n    width: 100%;\r\n  }\r\n  .tab-modal .widthModal {\r\n    width: 90%;\r\n  }\r\n  .tab-modal .tails-row {\r\n    grid-template-columns: repeat(1, 1fr);\r\n  }\r\n\r\n  .consultant-tails-tab .pd-tabs-view .nav-tabs .nav-link {\r\n    padding: 8px 15px;\r\n    font-size: 13px;\r\n    margin-right: 8px;\r\n    min-width: 80px;\r\n  }\r\n  .consultant-reports-data-select .col-md-10,\r\n  .consultant-reports-data-select .col-md-2,\r\n  .consultant-reports-data-select .col-md-3 {\r\n    flex: auto;\r\n    max-width: initial;\r\n    width: 100%;\r\n  }\r\n  .tracker-view ul {\r\n    width: 100%;\r\n  }\r\n  .city-landing-page .image img {\r\n    height: 500px;\r\n  }\r\n  div.ds-profile-page .tabs-view ul.nav li .nav-link {\r\n    font-size: 13px;\r\n    padding: 6px 14px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  div.city-landing-page .schools-btns .btn {\r\n    font-size: 14px;\r\n    padding: 6px 10px;\r\n  }\r\n  .my_properties_lists .trans-anttable table tr th:nth-child(2) {\r\n    min-width: 300px;\r\n  }\r\n\r\n  #myModalAddActivity.modal .modal-dialog {\r\n    width: 540px;\r\n    max-width: initial;\r\n  }\r\n  #myModalAddActivity.modal .width-70per {\r\n    width: 100% !important;\r\n  }\r\n\r\n  .consultant-report-views .col-10,\r\n  .consultant-report-views .col-2 {\r\n    width: 100%;\r\n  }\r\n  .consultant-report-views .col {\r\n    flex: auto;\r\n  }\r\n  ul.help_ul.nav {\r\n    flex-wrap: wrap;\r\n  }\r\n  ul.help_ul.nav li {\r\n    margin-bottom: 10px;\r\n  }\r\n  .my_property_details.cityImage {\r\n    height: 450px;\r\n  }\r\n\r\n  .city-landing-page.newOne.die-dataview .tabs-view ul.nav {\r\n    justify-content: center;\r\n    padding-left: 0;\r\n  }\r\n  div.city-landing-page.die-dataview .tabs-view ul.nav .nav-link {\r\n    font-size: 14px;\r\n    padding: 8px 20px;\r\n  }\r\n\r\n  .city-landing-page .city-bg {\r\n    font-size: 18px;\r\n  }\r\n  .city-landing-page .city-bg.banner-text {\r\n    display: none;\r\n  }\r\n  .city-landing-page .mobileView {\r\n    display: block;\r\n  }\r\n  .city-landing-page .mobileView + .col-md-4 {\r\n    margin-top: 1.5rem;\r\n  }\r\n  .city-landing-page .mobileView .city-bg.banner-text {\r\n    display: block;\r\n    margin-bottom: 0;\r\n  }\r\n  .city-landing-page.newOne h1.location {\r\n    top: 67px;\r\n    right: auto;\r\n    left: 75px;\r\n    background: #ededed;\r\n    padding: 3px;\r\n    border-radius: 5px;\r\n    display: none;\r\n  }\r\n  .cityListDesclimber {\r\n    width: 95%;\r\n    font-size: 18px;\r\n  }\r\n  div.check-list-page .main-view {\r\n    flex-direction: column-reverse;\r\n    justify-content: flex-end;\r\n  }\r\n  .check-list-page .main-view .tabs-check {\r\n    padding: 0;\r\n  }\r\n  .check-list-page .main-view .progress-view .image {\r\n    margin-bottom: 1.5rem;\r\n  }\r\n  .trans-anttable .ant-table-thead > tr > th {\r\n    min-width: 145px;\r\n  }\r\n  .tabPreferences .lis-view {\r\n    width: 90%;\r\n  }\r\n  .explore-nearby-view.mapsearchbar form {\r\n    width: 95%;\r\n  }\r\n  .resources-tab-view {\r\n    width: 85%;\r\n    margin: auto;\r\n  }\r\n  .resources-tab-view .botton-tab-view {\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n  .resources-tab-view .view-details {\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n  .resources-tab-view .tab-modal .widthModal {\r\n    width: 95%;\r\n  }\r\n  .resources-tab-view .botton-tab-view .item {\r\n    padding: 15px;\r\n  }\r\n  .resources-tab-view {\r\n    width: 750px;\r\n  }\r\n  form ul.qualities li .btn {\r\n    font-size: 14px;\r\n    padding: 6px 15px;\r\n  }\r\n  div.ant-dropdown-placement-bottomLeft .ant-dropdown-menu li a {\r\n    font-size: 16px;\r\n    padding: 8px 20px;\r\n    font-weight: 500;\r\n    color: #333333 !important;\r\n    display: block;\r\n  }\r\n  .calendar-view-page-schedule .fc .fc-daygrid-day-frame {\r\n    min-height: 70px;\r\n  }\r\n  .fc .fc-daygrid-day.fc-day-today {\r\n    height: 70px;\r\n  }\r\n  .city-landing-page .citylist {\r\n    display: none;\r\n  }\r\n  .mobileCitylist {\r\n    display: block;\r\n  }\r\n\r\n  /* .tabSliders > .owl-carousel .owl-item{\r\n  width:200px !important;\r\n} */\r\n  h1.backBtn button {\r\n    display: block;\r\n  }\r\n  .sharlotte-help-page h1 button.backBtn {\r\n    display: block;\r\n  }\r\n  .di_E_main .map-pic svg {\r\n    height: auto;\r\n    margin-bottom: 30px;\r\n  }\r\n\r\n  .tabSliders .owl-carousel {\r\n    position: static;\r\n    box-shadow: none;\r\n    width: 60%;\r\n    margin: auto;\r\n    margin-right: 0;\r\n  }\r\n  .tabSliders > .owl-carousel .owl-stage-outer {\r\n    width: 100%;\r\n  }\r\n  .tabSliders {\r\n    position: fixed;\r\n    top: 55px;\r\n    left: 0px;\r\n    width: 100%;\r\n    right: 0px;\r\n    background: rgba(255, 255, 255, 0.85);\r\n    box-shadow: 0px 0px 5px #959595;\r\n    z-index: 9;\r\n  }\r\n\r\n  .corporateHousing_Updates {\r\n    .p-request-form {\r\n      .form-horizontal {\r\n        width: 95%;\r\n        max-width: 710px;\r\n      }\r\n    }\r\n  }\r\n\r\n  #PackingRecommendations {\r\n    .modal-content .tails-row {\r\n      column-count: auto;\r\n    }\r\n  }\r\n} /*991px*/\r\n\r\n@media (min-width: 768px) and (max-width: 991px) {\r\n  .tabSliders .owl-carousel a.nav-item {\r\n    padding: 8px 14px;\r\n    font-size: 13px;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  @keyframes fadeInDown {\r\n    0% {\r\n      opacity: 0;\r\n      -webkit-transform: translate3d(0, 100%, 0);\r\n      transform: translate3d(0, 100%, 0);\r\n    }\r\n\r\n    to {\r\n      opacity: 1;\r\n      -webkit-transform: translateZ(0);\r\n      transform: translateZ(0);\r\n    }\r\n  }\r\n\r\n  .new-drag-drop .list-priority-view .item,\r\n  .new-drag-drop .list-priority-view {\r\n    width: 100%;\r\n  }\r\n\r\n  .fadeInDown {\r\n    -webkit-animation-name: fadeInDown;\r\n    animation-name: fadeInDown;\r\n  }\r\n  .relo-dsLanding .grid-view {\r\n    grid-template-columns: repeat(1, 1fr);\r\n    grid-gap: 25px;\r\n    max-width: 350px;\r\n    margin: auto;\r\n    width: 95%;\r\n  }\r\n  .footer_copyright ul.footer-ul-list::after {\r\n    width: 100% !important;\r\n  }\r\n\r\n  .footer_copyright ul.footer-ul-list li {\r\n    width: 45%;\r\n  }\r\n  .footer_copyright ul.footer-ul-list li a {\r\n    margin: 10px;\r\n  }\r\n  .footer_copyright ul.footer-ul-list {\r\n    flex-wrap: wrap;\r\n    justify-content: space-between;\r\n  }\r\n  #add-check-list .px-5 {\r\n    padding: 1rem !important;\r\n  }\r\n\r\n  #preference-modal.modal .modal-content,\r\n  #add-property-modal.modal .modal-content {\r\n    padding: 0px 20px;\r\n  }\r\n  .ds-solo-profile .profile-main-div {\r\n    grid-gap: 30px;\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .my_properties_lists h1 span.cursor.add-list {\r\n    margin: 15px 0px;\r\n  }\r\n  .my_properties_lists h1 span.cursor.add-list .btn {\r\n    padding: 6px 15px;\r\n  }\r\n  .main_getStartedPage .bannerpart h1 {\r\n    font-size: 2.5rem;\r\n  }\r\n  .main_getStartedPage .bannerpart h5 {\r\n    font-size: 17px;\r\n  }\r\n  .main_getStartedPage {\r\n    max-width: 95%;\r\n    padding-bottom: 50px;\r\n  }\r\n  .main_getStartedPage .col-md-8 {\r\n    max-width: 95%;\r\n    flex: auto;\r\n    padding: 30px;\r\n  }\r\n  .main_getStartedPage .col-md-8 .custom-checkbox {\r\n    width: 100%;\r\n  }\r\n  .col-md-4 {\r\n    position: relative;\r\n    width: 100%;\r\n    max-width: initial;\r\n    flex: auto;\r\n  }\r\n\r\n  .city-landing-page.newOne .map-right-view {\r\n    height: auto;\r\n    top: auto;\r\n    width: 95%;\r\n    left: 0px;\r\n    right: 0px;\r\n    margin: auto;\r\n    bottom: 0px;\r\n  }\r\n  .modal .city-landing-page.newOne .map-right-view {\r\n    top: auto;\r\n    height: auto;\r\n  }\r\n\r\n  .sharlotte-view .heightGrid .propertyresulttext {\r\n    height: 100%;\r\n  }\r\n\r\n  #propertymap .city-landing-page.newOne .tabs-view ul.nav,\r\n  #comparemap .city-landing-page.newOne .tabs-view ul.nav {\r\n    top: 35px;\r\n    justify-content: flex-start;\r\n    flex-wrap: wrap;\r\n  }\r\n  #propertymap .city-landing-page .tabs-view ul.nav .nav-link,\r\n  #comparemap .city-landing-page .tabs-view ul.nav .nav-link {\r\n    font-size: 10px;\r\n    padding: 6px 5px;\r\n    margin-bottom: 10px;\r\n    width: 27%;\r\n    margin-right: 10px;\r\n  }\r\n  #propertymap .city-landing-page.newOne .relomap-height,\r\n  #comparemap .city-landing-page.newOne .relomap-height {\r\n    top: 0px;\r\n    height: calc(100vh - 1px);\r\n    min-height: initial;\r\n  }\r\n  div.new_modal_pop .modal-dialog.modal-lg {\r\n    margin-top: 0px;\r\n  }\r\n\r\n  .city-landing-page.newOne .tabs-view ul.nav {\r\n    padding: 10px 30px;\r\n    justify-content: center;\r\n    top: 60px;\r\n  }\r\n  .sharlotte-view .heightGrid .propertyresulttext {\r\n    height: 100%;\r\n  }\r\n\r\n  div.city-landing-page .tabs-view ul.nav li {\r\n    margin-bottom: 0px;\r\n    width: auto;\r\n  }\r\n\r\n  div.city-landing-page.newOne .tabs-view ul.nav {\r\n    flex-wrap: nowrap;\r\n    top: 60px;\r\n  }\r\n\r\n  div.my_properties_lists .add-list .btn.theme-btn {\r\n    font-size: 13px !important;\r\n  }\r\n  #compare-community-Modal.modal .modal-content {\r\n    padding: 0px 20px;\r\n  }\r\n\r\n  #myModalDriversLicense.modal .modal-content {\r\n    padding: 0px 0;\r\n  }\r\n  div.check-list-page .main-view .tabs-check .tab-content {\r\n    margin-top: 0;\r\n  }\r\n  div.check-list-page .main-view .tabs-check {\r\n    margin-top: 0;\r\n  }\r\n  div.city-landing-page.newOne .relomap-height {\r\n    top: 108px;\r\n    height: calc(100vh - 110px);\r\n    margin: 0;\r\n  }\r\n  .consultant-tails-tab .pd-tabs-view .nav-tabs li {\r\n    margin-bottom: 10px;\r\n  }\r\n  #edit-property-modal.modal .modal-content label {\r\n    font-size: 14px;\r\n  }\r\n  #edit-property-modal.modal .modal-content {\r\n    padding: 0px;\r\n  }\r\n  .ds-solo-profile .profile-main-div.notable {\r\n    width: 90%;\r\n  }\r\n  .tracker-view ul li .text h3 {\r\n    font-size: 13px;\r\n  }\r\n\r\n  .city-landing-page .image img {\r\n    height: 400px;\r\n  }\r\n  .di_E_main {\r\n    padding: 15px;\r\n    margin-top: 15px;\r\n  }\r\n  .trans-anttable .table-top-input-btn {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    margin-bottom: 20px;\r\n  }\r\n  .usage_db .row-tails .card-body {\r\n    width: 100%;\r\n  }\r\n  .usage_db_top_form {\r\n    flex-wrap: wrap;\r\n  }\r\n  .usage_db_top_form.focus-input-label .floating-label {\r\n    width: 100%;\r\n    margin-bottom: 10px;\r\n  }\r\n  .dashboard-ds .col-md-8 {\r\n    flex: auto;\r\n    max-width: initial;\r\n  }\r\n  .my_properties_lists .main_grid .item .content {\r\n    padding: 10px 15px;\r\n  }\r\n  .my_properties_lists .main_grid .item p {\r\n    min-height: initial;\r\n    margin-bottom: 10px;\r\n  }\r\n  .my_properties_lists .main_grid {\r\n    grid-gap: 20px;\r\n  }\r\n  ul.help_ul.nav {\r\n    flex-wrap: wrap;\r\n  }\r\n  .mAppView + div .resources-tab-view > h1 {\r\n    font-size: 30px;\r\n    font-weight: 600;\r\n    padding: 15px 0;\r\n    margin: 0;\r\n    display: block;\r\n    background: #ffffff;\r\n    position: fixed;\r\n    left: 0px;\r\n    right: 0px;\r\n    top: 20px;\r\n  }\r\n  .mAppView + div .resources-tab-view > p {\r\n    margin-top: 95px;\r\n  }\r\n  ul.help_ul.nav li .btn {\r\n    padding: 6px 9px;\r\n    font-size: 14px;\r\n    margin-right: 10px;\r\n  }\r\n  .sharlotte-help-page .view {\r\n    padding: 15px;\r\n  }\r\n  .my_property_details.cityImage {\r\n    height: 350px;\r\n  }\r\n  div.submit-download-view .item {\r\n    margin: 30px auto;\r\n  }\r\n  .resources-tab-view {\r\n    width: 95%;\r\n    margin: auto;\r\n  }\r\n\r\n  .resources-tab-view .view-details .item-image {\r\n    width: auto;\r\n    height: auto;\r\n    min-width: 50px;\r\n    margin: 0;\r\n    margin-right: 10px;\r\n  }\r\n\r\n  .resources-tab-view .view-details img {\r\n    width: 50px;\r\n  }\r\n\r\n  .resources-tab-view .view-details .item {\r\n    padding: 15px 10px;\r\n    display: flex;\r\n    border-radius: 7px;\r\n    align-items: center;\r\n    cursor: pointer;\r\n  }\r\n  .resources-tab-view .view-details p {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    margin-bottom: 0px;\r\n    text-align: left;\r\n  }\r\n\r\n  .resources-tab-view .view-details .btn {\r\n    display: none;\r\n  }\r\n  .resources-tab-view h2 {\r\n    font-weight: 600;\r\n    font-size: 1.5rem;\r\n  }\r\n  .resources-tab-view .botton-tab-view .item {\r\n    padding: 15px 10px;\r\n    display: flex;\r\n    border-radius: 7px;\r\n    align-items: center;\r\n  }\r\n  .resources-tab-view .botton-tab-view .item span {\r\n    width: auto;\r\n    height: auto;\r\n    min-width: 40px;\r\n    margin: 0;\r\n    margin-right: 10px;\r\n  }\r\n  .resources-tab-view .botton-tab-view .item img {\r\n    width: 40px !important;\r\n  }\r\n  .resources-tab-view .botton-tab-view .item h3 {\r\n    font-size: 15px;\r\n    text-align: left;\r\n    min-height: initial;\r\n    white-space: normal;\r\n    word-break: break-word;\r\n    width: 100%;\r\n    margin-top: 0;\r\n  }\r\n\r\n  .resources-tab-view .tab-modal .tails-row {\r\n    grid-template-columns: repeat(1, 1fr);\r\n    grid-gap: 0;\r\n  }\r\n  .resources-tab-view .botton-tab-view {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n  .resources-tab-view .view-details {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n  .resources-tab-view {\r\n    width: 90%;\r\n  }\r\n  form ul.qualities {\r\n    flex-wrap: wrap;\r\n  }\r\n  form ul.qualities li {\r\n    margin-bottom: 15px;\r\n  }\r\n  .relo-step-from .two-tails {\r\n    flex-wrap: wrap;\r\n  }\r\n  .relo-step-from .two-tails .form-group {\r\n    width: 100%;\r\n  }\r\n  #compare-community-Modal .modal-header .close {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 15px;\r\n  }\r\n  #compare-community-Modal .modal-header .item {\r\n    display: block !important;\r\n  }\r\n  #compare-community-Modal .modal-header {\r\n    flex-direction: column-reverse;\r\n    justify-content: flex-start;\r\n    align-items: flex-start;\r\n  }\r\n  div#compare-community-Modal .modal-header .btn {\r\n    padding-left: 0;\r\n  }\r\n  .di_E_score_card_gridView .item {\r\n    min-height: 250px;\r\n    padding: 0;\r\n  }\r\n  .die-dataview .relomap-height .gmnoprint.gm-style-mtc-bbw {\r\n    top: 0px !important;\r\n  }\r\n  .religious_mainView div#mapus {\r\n    top: 105px;\r\n  }\r\n  p.nodataFound {\r\n    display: flex;\r\n    height: calc(100% - 110px);\r\n    justify-content: center;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n    padding: 10px;\r\n    width: 80%;\r\n    margin: auto;\r\n  }\r\n  .relomap-height .gmnoprint {\r\n    top: 30px;\r\n  }\r\n\r\n  .religious_mainView div#mapus .gmnoprint {\r\n    top: 0px;\r\n    left: auto !important;\r\n    right: 0px;\r\n    top: 75px;\r\n  }\r\n  button.gm-svpc {\r\n    display: none;\r\n  }\r\n  .modal .city-landing-page.newOne .heightGrid {\r\n    height: calc(100vh - 230px);\r\n  }\r\n  .modal .city-landing-page.newOne .full + .heightGrid {\r\n    height: 150px;\r\n  }\r\n  .calendar-view-page-schedule .fc .fc-daygrid-day-frame {\r\n    min-height: 50px;\r\n  }\r\n  .fc .fc-daygrid-day.fc-day-today {\r\n    height: 50px;\r\n  }\r\n  .city-landing-page .amenities ul li {\r\n    font-size: 14px;\r\n  }\r\n  .city-landing-page .amenities ul li img {\r\n    width: 25px;\r\n    margin-right: 5px;\r\n  }\r\n  .city-landing-page .tabs-view {\r\n    padding-top: 20px;\r\n  }\r\n  .city-landing-page.propertyDetails .tabs-view {\r\n    padding-top: 0;\r\n  }\r\n  .city-landing-page.propertyDetails header {\r\n    padding-top: 30px;\r\n  }\r\n\r\n  .tabs-view .tab-content {\r\n    padding-top: 10px;\r\n  }\r\n\r\n  .tabSliders .owl-carousel a.nav-item {\r\n    padding: 8px 15px;\r\n    font-size: 14px;\r\n    width: 100%;\r\n  }\r\n  .city-landing-page.newOne h1.backBtn button {\r\n    top: 73px;\r\n    left: 10px;\r\n    background: #ffffff;\r\n    color: #000;\r\n    border: 2px solid #ffffff;\r\n    font-weight: 600;\r\n    /* border: 1px solid #837f7f; */\r\n  }\r\n  .map-right-view .slider .item a {\r\n    min-width: initial;\r\n  }\r\n\r\n  /* .explore-nearby-view.mapsearchbar {\r\n    padding-bottom: 20px;\r\n  } */\r\n  /* .explore-nearby-view.mapsearchbar form{\r\n    margin-top: 15px;\r\n  } */\r\n  .city-landing-page .tabs-view #overview {\r\n    margin-top: 20px;\r\n  }\r\n  .city-landing-page.newOne .mapsearchbar + h1 + h1 + div .heightGrid {\r\n    height: calc(100vh - 260px);\r\n  }\r\n  .city-landing-page.newOne .mapsearchbar + h1 + h1 + div .full + .heightGrid {\r\n    height: 150px;\r\n  }\r\n  h1.backBtn button {\r\n    display: flex;\r\n  }\r\n  .city-landing-page.newOne .heightGrid {\r\n    height: 50px;\r\n  }\r\n  .city-landing-page.newOne .full + .heightGrid {\r\n    height: calc(100vh - 190px);\r\n  }\r\n  /* .tabSliders > .owl-carousel .owl-item {\r\n    width: 160px !important;\r\n  } */\r\n  /* .tabSliders > .owl-carousel .owl-stage-outer {\r\n    width: calc(100% - 70px);\r\n    margin-top: 6px;\r\n} */\r\n\r\n  .main_getStartedPage .bannerpart {\r\n    padding: 20px 0;\r\n  }\r\n\r\n  .corporateHousing_Updates {\r\n    .p-request-form {\r\n      .form-horizontal {\r\n        padding: 30px;\r\n      }\r\n    }\r\n  }\r\n  .ds-solo-profile .profile-main-div p.note {\r\n    grid-column: auto;\r\n  }\r\n\r\n  .tabSliders .owl-carousel.owl-drag .owl-item {\r\n    width: auto !important;\r\n  }\r\n  .tabSliders .owl-carousel .owl-stage {\r\n    width: 750px !important;\r\n  }\r\n\r\n  .tabSliders .owl-carousel {\r\n    width: calc(100% - 300px);\r\n  }\r\n  .tabSliders .owl-carousel.owl-drag .owl-item:last-child {\r\n    margin-right: 60px !important;\r\n  }\r\n\r\n  .tabSliders .owl-carousel.owl-drag .owl-item {\r\n    margin-right: 12px !important;\r\n  }\r\n  .ds-solo-profile .content {\r\n    padding: 20px;\r\n  }\r\n\r\n  .map-right-view .owl-carousel .owl-item {\r\n    width: auto !important;\r\n  }\r\n\r\n  .calendar-view-page-schedule .fc-event {\r\n    bottom: -25px;\r\n  }\r\n  .calendar-view-page-schedule .main-view .item .bg-color {\r\n    padding: 10px 15px;\r\n  }\r\n\r\n  .resources-tab-view .text-box {\r\n    margin: 10px 0px 20px;\r\n  }\r\n  .resources-tab-view .text-box p {\r\n    font-size: 16px;\r\n  }\r\n  .resources-tab-view > p {\r\n    background: #e3e3e3;\r\n    padding: 15px;\r\n    border-radius: 7px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .resources-tab-view > h1 {\r\n    text-align: center;\r\n    font-size: 25px;\r\n    font-weight: 700;\r\n    margin-top: -20px;\r\n  }\r\n\r\n  .custommultiCheckBox #multi-rest i.fa.fa-angle-right {\r\n    width: 25px;\r\n    position: absolute;\r\n    top: 15px;\r\n    right: -25px;\r\n    background: #d7c7fa;\r\n    height: 40px;\r\n    font-size: 17px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 0px 5px 5px 0;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .custommultiCheckBox #multi-rest {\r\n    background: transparent;\r\n    width: 0;\r\n    left: -55px;\r\n    .filterIcon {\r\n      width: 40px;\r\n      position: absolute;\r\n      top: 14px;\r\n      right: -37px;\r\n      background: #d7c7fa;\r\n      height: 50px;\r\n      font-size: 17px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      border-radius: 0px 5px 5px 0;\r\n      cursor: pointer;\r\n      padding: 3px 10px 3px 10px;\r\n      img {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n\r\n  .custommultiCheckBox #multi-rest .textView {\r\n    display: none;\r\n    width: 0;\r\n  }\r\n  .custommultiCheckBox #multi-rest.active {\r\n    background: #ffffff;\r\n    width: 300px;\r\n    left: 0;\r\n    .filterIcon {\r\n      font-size: 18px;\r\n      right: 0px;\r\n      background: transparent;\r\n      top: -5px;\r\n      &::before {\r\n        content: \"\\f05c\";\r\n        content: \"\\f00d\";\r\n        font-family: FontAwesome;\r\n        position: absolute;\r\n        right: 0px;\r\n        top: 0px;\r\n        left: 0px;\r\n        margin: auto;\r\n        bottom: 0;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n      }\r\n      img {\r\n        display: none;\r\n      }\r\n    }\r\n\r\n    .textView {\r\n      width: auto;\r\n      display: block;\r\n    }\r\n  }\r\n\r\n  .custommultiCheckBox #multi-rest.active .fa-angle-right:before {\r\n    transform: rotate(-180deg);\r\n  }\r\n  .check-list-page .main-view {\r\n    margin-top: 75px;\r\n  }\r\n  .check-list-page ul.nav-tabs.scroll-ul {\r\n    top: 40px;\r\n  }\r\n  .check-list-page {\r\n    padding-top: 10px;\r\n  }\r\n  div.check-list-page ul.nav-tabs .nav-item .nav-link {\r\n    padding: 6px 13px;\r\n    font-size: 14px;\r\n    min-width: 70px;\r\n  }\r\n  .check-list-page .top-task-btns a.task:hover {\r\n    background: transparent;\r\n  }\r\n  .check-list-page .top-task-btns {\r\n    top: 5px;\r\n    display: flex;\r\n    a.task {\r\n      background: transparent;\r\n      border: 0;\r\n      margin-right: 0;\r\n      padding: 0;\r\n      margin-left: 10px;\r\n      span {\r\n        display: none;\r\n      }\r\n      img {\r\n        display: block;\r\n      }\r\n      .bi {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        width: 28px;\r\n        height: 28px;\r\n        border-radius: 50%;\r\n        background: #d7c7fa;\r\n        font-size: 23px;\r\n      }\r\n      .bi-plus::before {\r\n        font-weight: 600 !important;\r\n      }\r\n    }\r\n  }\r\n\r\n  .explore-nearby-view.mapsearchbar {\r\n    position: absolute;\r\n    right: 0;\r\n    padding: 0;\r\n    margin: 0;\r\n    top: 170px;\r\n    & > span {\r\n      background: #d7c7fa;\r\n      font-size: 16px;\r\n      position: absolute;\r\n      right: 10px;\r\n      z-index: 9;\r\n      border-radius: 6px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      padding: 12px 8px;\r\n      i.fa.fa-search {\r\n        display: block;\r\n      }\r\n    }\r\n    & > span:has(+ .active) {\r\n      background: #ffffff;\r\n      padding-top: 15px;\r\n      top: 10px;\r\n      z-index: 9999;\r\n      i::before {\r\n        content: \"\\f00d\";\r\n      }\r\n    }\r\n\r\n    form {\r\n      display: none;\r\n      &.active {\r\n        display: block;\r\n        width: 350px;\r\n        right: 0px;\r\n        position: relative;\r\n        background: #ffffff;\r\n        padding: 15px 15px;\r\n        width: 100vw;\r\n        left: 0;\r\n        top: 0;\r\n      }\r\n      input {\r\n        background: #f2f2f2;\r\n        padding-left: 17px;\r\n      }\r\n    }\r\n    .input-group {\r\n      width: 90%;\r\n      margin: auto;\r\n    }\r\n    .btn.btn-default {\r\n      display: flex;\r\n      align-items: center;\r\n      height: 100%;\r\n      color: #000;\r\n      padding: 8px 14px 8px 11px;\r\n      b {\r\n        display: none;\r\n      }\r\n      i.fa.fa-search {\r\n        display: block !important;\r\n        color: #000000;\r\n        position: static;\r\n      }\r\n    }\r\n    i.fa.fa-search {\r\n      display: none;\r\n    }\r\n\r\n    &.overview {\r\n      position: relative;\r\n      padding-bottom: 60px;\r\n      margin-top: 45px;\r\n      top: 8px;\r\n      & > span {\r\n        display: none;\r\n      }\r\n      form {\r\n        display: block;\r\n      }\r\n    }\r\n    &.transit {\r\n      top: 125px;\r\n    }\r\n    &.schools {\r\n      top: 250px;\r\n    }\r\n  }\r\n\r\n  #transit .communityNew-publictransitapp.citybg {\r\n    display: block;\r\n    position: relative;\r\n    width: 100%;\r\n    height: calc(100vh - 110px);\r\n    .isochronestyles {\r\n      top: 40px;\r\n      left: -290px;\r\n      transition: all 0.05s;\r\n      &.active {\r\n        left: 10px;\r\n      }\r\n      i.fa.fa-times {\r\n        position: absolute;\r\n        right: 20px;\r\n        top: 16px;\r\n        cursor: pointer;\r\n        font-size: 20px;\r\n        display: block !important;\r\n      }\r\n    }\r\n    .filterIcon {\r\n      width: 40px;\r\n      position: absolute;\r\n      top: 40px;\r\n      left: 0px;\r\n      background: #d7c7fa;\r\n      height: 50px;\r\n      font-size: 17px;\r\n      display: flex !important;\r\n      align-items: center;\r\n      justify-content: center;\r\n      border-radius: 0px 5px 5px 0;\r\n      cursor: pointer;\r\n      padding: 3px 10px 3px 10px;\r\n\r\n      img {\r\n        width: 100%;\r\n      }\r\n      &.active {\r\n        background: transparent;\r\n        img {\r\n          display: none;\r\n        }\r\n      }\r\n    }\r\n  }\r\n} /*767px*/\r\n\r\n@media (max-width: 639px) {\r\n  .city-landing-page.newOne h1.location {\r\n    display: none;\r\n  }\r\n  .tabSliders .owl-carousel {\r\n    width: calc(100% - 75px);\r\n  }\r\n  .tabSliders .owl-carousel .owl-stage {\r\n    width: 550px !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 575px) {\r\n  .relonav-login .form-signin {\r\n    max-width: 80%;\r\n    background: #ffffff;\r\n    border-radius: 10px;\r\n    padding: 30px;\r\n    margin: auto;\r\n    position: fixed;\r\n    left: 0px;\r\n    right: 0px;\r\n    bottom: 35px;\r\n  }\r\n  .relonav-login .item {\r\n    display: block;\r\n    width: auto;\r\n    height: auto;\r\n  }\r\n  .relonav-login .item img.logoBanner {\r\n    height: 100vh;\r\n    position: absolute;\r\n    top: 0px;\r\n    bottom: 0px;\r\n    left: 0px;\r\n    right: 0;\r\n  }\r\n  .relonav-login img {\r\n    max-width: 100%;\r\n    height: auto;\r\n  }\r\n  .relonav-login h1 + span {\r\n    font-size: 15px;\r\n  }\r\n  .weather-view-page .weather-view-sub-details ul li {\r\n    padding: 0px 10px;\r\n  }\r\n  .weather-view-page .weather-view-sub-details ul li img {\r\n    height: 25px;\r\n  }\r\n  .weather-view-page .weather-view-sub-details ul li span {\r\n    font-size: 15px;\r\n    padding-left: 10px;\r\n  }\r\n  .weather-view-page .weather-view-sub-details ul li p {\r\n    font-size: 15px;\r\n    padding-left: 0;\r\n    margin-bottom: 0;\r\n  }\r\n  .weather-view-page .weather-view-week-details .item {\r\n    width: 30%;\r\n  }\r\n  .weather-view-page .weather-view-week-details .item p {\r\n    font-size: 25px;\r\n    font-weight: 800;\r\n  }\r\n  .weather-view-page .weather-view-week-details .item img {\r\n    height: 70px;\r\n  }\r\n  .weather-view-page .weather-view-week-details .item span {\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n  }\r\n  div.city-landing-page.newOne .tabs-view ul.nav {\r\n    padding: 10px 5px;\r\n  }\r\n  div.city-landing-page.newOne .tabs-view ul.nav .nav-link {\r\n    font-size: 9px;\r\n    padding: 6px 20px;\r\n    margin: 0;\r\n    margin-right: 8px;\r\n  }\r\n  div.city-landing-page.die-dataview .tabs-view ul.nav .nav-link {\r\n    font-size: 14px;\r\n    padding: 6px 14px;\r\n    margin: 0;\r\n    margin-right: 8px;\r\n  }\r\n\r\n  div.city-landing-page.newOne .tabs-view ul.nav li:last-child .nav-link {\r\n    margin: 0;\r\n  }\r\n  .city-landing-page .image img {\r\n    height: 250px;\r\n  }\r\n\r\n  #myModalAddActivity.modal .modal-dialog {\r\n    width: 100%;\r\n    max-width: initial;\r\n  }\r\n\r\n  .my_properties_lists h1 {\r\n    align-items: center;\r\n  }\r\n  .main_getStartedPage .formView h1 a.help {\r\n    display: block;\r\n    margin: 0;\r\n    margin-top: 5px;\r\n  }\r\n  .my_property_details.cityImage {\r\n    height: 250px;\r\n  }\r\n  .my_properties_lists h1.main {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  #myModalAddActivity .checbox-label {\r\n    margin-top: 0;\r\n    margin-bottom: 15px;\r\n  }\r\n  .modal-fullscreen {\r\n    padding: 0 !important;\r\n  }\r\n  .modal-fullscreen .modal-dialog {\r\n    width: 100%;\r\n    max-width: none;\r\n    height: 100%;\r\n    margin: 0;\r\n  }\r\n  .modal-fullscreen .modal-content {\r\n    height: 100%;\r\n    border: 0;\r\n    border-radius: 0;\r\n  }\r\n  .modal-fullscreen .modal-body {\r\n    overflow-y: auto;\r\n  }\r\n\r\n  .resources-tab-view {\r\n    width: 95%;\r\n    margin: auto;\r\n  }\r\n\r\n  .resources-tab-view .botton-tab-view .btn {\r\n    font-size: 17px;\r\n    padding: 10px 10px;\r\n  }\r\n  #propertymap .city-landing-page .tabs-view ul.nav .nav-link,\r\n  #comparemap .city-landing-page .tabs-view ul.nav .nav-link {\r\n    width: 30%;\r\n  }\r\n  .modal .tabs-view ul.nav .nav-link a {\r\n    font-size: 12px;\r\n  }\r\n  #propertymap.modal.new_modal_pop .pointer.close,\r\n  #comparemap .modal.new_modal_pop .pointer.close {\r\n    top: 10px;\r\n  }\r\n  .my_properties_lists h1 span.cursor.add-list .btn {\r\n    padding: 6px 12px;\r\n  }\r\n  .calendar-view-page-schedule .fc .fc-daygrid-day-frame {\r\n    min-height: initial;\r\n  }\r\n  .fc .fc-daygrid-day.fc-day-today {\r\n    height: 50px;\r\n  }\r\n  .fc .fc-view-harness {\r\n    height: 300px !important;\r\n  }\r\n  .btn.theme-btn {\r\n    padding: 7px 17px;\r\n  }\r\n  .main_getStartedPage .bannerpart h1 {\r\n    font-size: 27px;\r\n  }\r\n  .main_getStartedPage .bannerpart h5 {\r\n    font-size: 15px;\r\n  }\r\n  .custom-file-upimg_multy {\r\n    flex-wrap: wrap;\r\n  }\r\n  #compare-community-Modal .item-address h1 {\r\n    font-size: 18px;\r\n    align-items: flex-start;\r\n  }\r\n  .main_getStartedPage .checkbtns .btn {\r\n    padding: 5px 20px;\r\n    font-size: 14px;\r\n  }\r\n  .main_getStartedPage .col-md-8 {\r\n    max-width: 100%;\r\n    padding: 20px;\r\n  }\r\n  input#address {\r\n    font-size: 14px;\r\n  }\r\n  .weather-view-page .weather-view-main-details .fa-clouds {\r\n    font-size: 65px;\r\n  }\r\n  .weather-view-page .weather-view-main-details span {\r\n    font-size: 3rem;\r\n  }\r\n  .weather-view-page .weather-view-main-details p {\r\n    font-size: 18px;\r\n  }\r\n  .city-landing-page .amenities ul li {\r\n    font-size: 14px;\r\n    min-width: initial;\r\n    width: 50%;\r\n  }\r\n\r\n  .help-Modal-box .modal-dialog {\r\n    width: 95%;\r\n    margin: 30px auto;\r\n  }\r\n  .help-Modal-box .modal-content h1 span {\r\n    font-size: 2rem;\r\n  }\r\n  .help-Modal-box .modal-content .letsstart {\r\n    font-size: 3rem;\r\n    line-height: 1.5;\r\n    text-align: left;\r\n    margin: 50px 0;\r\n  }\r\n\r\n  .tabSliders .owl-carousel .item {\r\n    text-align: center;\r\n  }\r\n  .tabSliders .owl-carousel a.nav-item {\r\n    /* width: 95%;\r\n    padding: 8px 8px; */\r\n  }\r\n  /* .tabSliders > .owl-carousel .owl-item {\r\n    width: min-content !important;\r\n    min-width: 130px;\r\n  }\r\n  .tabSliders .owl-carousel a.nav-item{\r\n    display: inline-block;\r\n    width: 90%;\r\n    margin: auto;\r\n  } */\r\n} /*575px*/\r\n\r\n@media (max-width: 400px) {\r\n  div.city-landing-page.die-dataview .tabs-view ul.nav .nav-link {\r\n    font-size: 13px;\r\n    padding: 6px 13px;\r\n  }\r\n  .my_properties_lists h1 span.cursor.add-list .btn {\r\n    padding: 6px 9px;\r\n  }\r\n  .check-list-page .top_label-div > span {\r\n    min-width: 120px;\r\n    align-items: center;\r\n  }\r\n  .listViewOnMap_school {\r\n    max-width: 335px;\r\n    .subnew {\r\n      .item {\r\n        a {\r\n          font-size: 13px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .chat_width .modal-content {\r\n    padding: 25px;\r\n  }\r\n  .alternate-user-modal.myModalconfirmdes .modal-password-content,\r\n  .ds-profile-page .chat_msgs .left_chat_view,\r\n  .ds-profile-page .chat_msgs .right_chat_view {\r\n    width: 95%;\r\n  }\r\n  .chat_footer-fullview .chat_msgs .right_chat {\r\n    font-size: 14px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
